import NavBar from '@/components/Nav.vue';
import Redeem from '@/components/Redeem.vue';

import functions from '@/functions.js';
import enums from '@/configs/enums.js';

export default {
    name: 'ComposeDetailPage',
    components: {
        NavBar,
        Redeem
    },
    data() {
        return {
            timer: null,
            enough: true,
            exists: [],
            states: enums.productState,
            dateFormat: functions.dateFormat,
            entityKey: null,
            successType: '',
            product: {organization: {}, issuer: {}, tags: []},
            showWelfareAlert: false,
            showWelfareInfo: false,
            welfares: [],
            welfareIndex: 0
        }
    },
    created() {
        this.$http.get('compose/' + this.$route.params.id + '?type=' + this.$route.query.type).then(result => {
            this.exists = result.data.exists;
            this.product = result.data.product;
            this.product.needs.forEach(need => {
                if (this.exists.indexOf(need.id) == -1) {
                    this.enough = false;
                }
            });
            this.setState(this.product);
            this.timer = setInterval(() => {
                this.setState(this.product);
                if (this.product.state == this.states.offline) {
                    clearInterval(this.timer);
                }
            }, 1000);
        })
    },
    unmounted() {
        clearInterval(this.timer);
    },
    methods: {
        compose() {
            if (this.enough) {
                this.$http.post('compose/' + this.$route.params.id + '?type=' + this.$route.query.type).then(result => {
                    // 区分合成的是权益还是藏品                    
                    if (this.$route.query.type == 1) {
                        this.showWelfareAlert = true;
                        this.welfareIndex = 0;
                        this.welfares = result.data.welfares;
                    } else {
                        this.successType = 'confirm';
                        this.entityKey = result.data.entity_id;
                    }
                })
            }
        },
        setState(product) {
            let now = Date.parse(new Date);
            if (product.state == this.states.waiting && now >= Date.parse(new Date(product.release_time))) {
                product.state = this.states.normal;
            } else if (product.state == this.states.normal) {
                let offlineTime = Date.parse(new Date(product.offline_time));
                if (offlineTime && now > offlineTime) {
                    product.state = this.states.offline;
                }
            }
        }
    }
}